import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Box, Button, Checkbox, Collapse, Divider, FormControlLabel, FormGroup, FormHelperText, Grid2, IconButton, Paper, TextField, Typography, useTheme } from "@mui/material";
import { FieldArray, Formik } from "formik";
import { useAssignPermissionMutation, useGetAllRoleQuery, useLazyGetCheckRolePermissionQuery } from "store/slices/apis/rolePackageSlice";
import { useParams } from "react-router-dom";
import * as Yup from 'yup';
import { dispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
    ENGINEERING_DCOCUMENT_CREATE, ENGINEERING_DCOCUMENT_EDIT, ENGINEERING_DCOCUMENT_DELETE,
    ENGINEERING_DCOCUMENT_APPROVAL,
    ENGINEERING_DCOCUMENT_VIEW, KEY_ISSUE_VIEW, KEY_ISSUE_CREATE, KEY_ISSUE_EDIT, KEY_ISSUE_DELETE, KEY_ISSUE_APPROVAL,
    RISK_VIEW,
    RISK_CREATE,
    RISK_EDIT,
    RISK_DELETE,
    RISK_APPROVAL,
    KEY_CLEARANCE_VIEW,
    KEY_CLEARANCE_CREATE,
    KEY_CLEARANCE_EDIT,
    KEY_CLEARANCE_DELETE,
    KEY_CLEARANCE_APPROVAL,
    SAFETY_CREATE,
    SAFETY_VIEW,
    SAFETY_EDIT,
    SAFETY_DELETE,
    SAFETY_APPROVAL,
    QUALITY_VIEW,
    QUALITY_CREATE,
    QUALITY_EDIT,
    QUALITY_DELETE,
    QUALITY_APPROVAL,
    CHANGE_ORDER_VIEW,
    CHANGE_ORDER_CREATE,
    CHANGE_ORDER_EDIT,
    CHANGE_ORDER_DELETE,
    CHANGE_ORDER_APPROVAL,
    CLAIM_VIEW,
    CLAIM_EDIT,
    CLAIM_DELETE,
    CLAIM_APPROVAL,
    CLAIM_CREATE,
    MILESTONE_VIEW,
    // MILESTONE_CREATE,
    // MILESTONE_EDIT,
    // MILESTONE_DELETE,
    // MILESTONE_APPROVAL,
    PM_VIEW,
    PM_CREATE,
    PM_EDIT,
    PM_DELETE,
    PM_APPROVAL,
} from "config";
import { USERS_ADD } from "config";
import { USERS_BULK_UPLOAD } from "config";
import { USERS_EDIT } from "config";
import { USERS_DISABLE } from "config";
import { BULK_USER_TRANSACTION_VIEW } from "config";
import { ROLE_ADD } from "config";
import { ROLE_EDIT } from "config";
import { ROLE_DELETE } from "config";
import { PERMISSION_ADD } from "config";
import { FILE_ADD } from "config";
import { FILE_VIEW } from "config";
import { FILE_APPROVAL } from "config";
import { SCHEDULE_ACCESS } from "config";
import { CONSTRUCTION_ACCESS } from "config";
import { MILESTONE_ACCESS } from "config";
import { MILESTONE_APPROVAL } from "config";
import { ENGINEERING_ACCESS } from "config";
import { ENGINEERING_MANAGE_DRAWING } from "config";
import { PM_ACCESS } from "config";
import { MONTE_CARLO_SIMULATION_ACCESS } from "config";
import { MONTE_CARLO_SIMULATION_CREATE } from "config";
import { MONTE_CARLO_SIMULATION_VIEW } from "config";
import { MONTE_CARLO_SIMULATION_RESULT } from "config";
import { MONTE_CARLO_SIMULATION_PUBLISH } from "config";
import { BIM_VIEWER_ACCESS } from "config";
import { FINANCIAL_PROGRESS_ACCESS } from "config";
import { PAYMENT_TRACKER_ACCESS } from "config";
import { BOQ_ACCESS } from "config";
import { VENDOR_PERFORMANCE_TRACKER_ACCESS } from "config";
import { PROCUREMENT_ACCESS } from "config";
import { CHANGE_ORDER_ACCESS } from "config";
import { CLAIM_ACCESS } from "config";
import { KEY_ISSUE_ACCESS } from "config";
import { RISK_ACCESS } from "config";
import { KEY_CLEARANCE_ACCESS } from "config";
import { SAFETY_ACCESS } from "config";
import { QUALITY_ACCESS } from "config";
import { IMAGE_GALLERY_ACCESS } from "config";
import { IMAGE_GALLERY_VIEW } from "config";
import { IMAGE_GALLERY_CREATE } from "config";
import { IMAGE_GALLERY_EDIT } from "config";
import { IMAGE_GALLERY_DELETE } from "config";
import { IMAGE_GALLERY_APPROVAL } from "config";
import { DPR_QUANTITY_ACCESS } from "config";
import { DPR_QUANTITY_EDIT } from "config";
import { DPR_PM_ACCESS } from "config";
import { DPR_PM_EDIT } from "config";
import { PROJECT_SETTING_ACCESS } from "config";
import { PROJECT_SETTING_CREATE } from "config";
import { PROJECT_SETTING_VIEW } from "config";
import { PROJECT_SETTING_EDIT } from "config";
import { PROJECT_SETTING_DELETE } from "config";
import { NORMS_ACCESS } from "config";
import { NORMS_EDIT } from "config";
import { WORKFLOW_ACCESS } from "config";
import { WORKFLOW_CREATE } from "config";
import { WORKFLOW_EDIT } from "config";
import { DATA_METRICS_ACCESS } from "config";
import { DATA_METRICS_VIEW } from "config";
import { DATA_METRICS_CREATE } from "config";
import { DATA_METRICS_EDIT } from "config";
import { DATA_METRICS_DELETE } from "config";
import { HELP_FEATURE_LIST_ACCESS } from "config";
import { HELP_DATA_SETS_LIST_ACCESS } from "config";
import { PROJECT_HOME_ACCESS } from "config";
import { SMT_SCHEDULE_ACCESS } from "config";
import { SMT_CONSTRUCTION_ACCESS } from "config";
import { SMT_MILESTONE_ACCESS } from "config";
import { SMT_ENGINEERING_ACCESS } from "config";
import { SMT_PM_ACCESS } from "config";
import { SMT_MANPOWERPRODUCT_ACCESS } from "config";
import { FINANCIAL_PROGRESS_DASH_ACCESS } from "config";
import { PAYMENT_TRACKER_DASH_ACCESS } from "config";
import { VENDOR_DASH_ACCESS } from "config";
import { PROCUREMENT_DASH_ACCESS } from "config";
import { CLAIM_AND_CHANGE_ORDER_DASH_ACCESS } from "config";
import { ISSUES_DASH_ACCESS } from "config";
import { KEY_CLEATANCE_DASH_ACCESS } from "config";
import { RISK_DASH_ACCESS } from "config";
import { SAFETY_DASH_ACCESS } from "config";
import { QUALITY_DASH_ACCESS } from "config";
import { FILE_ACCESS } from "config";
import { ROLE_ACCESS } from "config";
import { BULK_USER_TRANSACTION_ACCESS } from "config";
import { USERS_ACCESS } from "config";
import { PERMISSION_ACCESS } from "config";
import { MANPOWER_ACCESS } from "config";
import { PROGRAM_DASHBOARD_MENU } from "config";
import { PROJECT_MENU } from "config";
import { USER_MANAGEMENT_MENU } from "config";
import { PORTFOLIO_DASHBOARD_MENU } from "config";
import {ReactComponent as ChevronDownIcon} from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"
import {ReactComponent as ChevronUPIcon} from "assets/PwC_Funct_Icons_ChevronUp_Outline_Black_RGB.svg"
import { height, width } from "@mui/system";

const menusModule = [
    {
        title: "Global Menus",
        children: [
            {
                label: "Portfolio Dashboard",
                key: "portfolio_dashboard",
                permissions: [
                    { label: "Access", value: PORTFOLIO_DASHBOARD_MENU },
                ]
            },
            {
                label: "Program Dashboard",
                key: "program_dashboard",
                permissions: [
                    { label: "Access", value: PROGRAM_DASHBOARD_MENU },
                ]
            },
            {
                label: "Projects",
                key: "project_menu",
                permissions: [
                    { label: "Access", value: PROJECT_MENU },
                ]
            },
            {
                label: "User Management",
                key: "user_management_menu",
                permissions: [
                    { label: "Access", value: USER_MANAGEMENT_MENU },
                ]
            },
        ]
    },
    {
        title: "Project Dashboard",
        children: [
            {
                label: "Project Home",
                key: "project_home",
                permissions: [
                    { label: "Home Access", value: PROJECT_HOME_ACCESS },
                ]
            },
            {
                label: "Schedule, Monitoring & Tracking",
                key: "smt",
                permissions: [
                    { label: "Schedule", value: SMT_SCHEDULE_ACCESS },
                    { label: "Construction", value: SMT_CONSTRUCTION_ACCESS },
                    { label: "Milestone", value: SMT_MILESTONE_ACCESS },
                    { label: "Engineering", value: SMT_ENGINEERING_ACCESS },
                    { label: "P&M", value: SMT_PM_ACCESS },
                    { label: "Manpower & Productivity", value: SMT_MANPOWERPRODUCT_ACCESS },
                ]
            },
            {
                label: "Cost",
                key: "cost_dashboard",
                permissions: [
                    { label: "Financial Progress Access", value: FINANCIAL_PROGRESS_DASH_ACCESS },
                    { label: "Payment Tracker Access", value: PAYMENT_TRACKER_DASH_ACCESS },
                ]
            },
            {
                label: "Procurement",
                key: "procurement_dashboard",
                permissions: [
                    { label: "Vendor Performance Tracker Access", value: VENDOR_DASH_ACCESS },
                    { label: "Procurement Access", value: PROCUREMENT_DASH_ACCESS },
                ]
            },
            {
                label: "Claims and Change",
                key: "claim_and_change_dashboard",
                permissions: [
                    { label: "Claim & Change Order Access", value: CLAIM_AND_CHANGE_ORDER_DASH_ACCESS },
                ]
            },
            {
                label: "Risk",
                key: "risk_dashboard",
                permissions: [
                    { label: "Issues Access", value: ISSUES_DASH_ACCESS },
                    { label: "Key Clearances Access", value: KEY_CLEATANCE_DASH_ACCESS },
                    { label: "Risk Access", value: RISK_DASH_ACCESS },
                    { label: "Safety Access", value: SAFETY_DASH_ACCESS },
                    { label: "Quality Access", value: QUALITY_DASH_ACCESS },
                ]
            },
        ]
    },
    {
        title: "User Management",
        children: [
            {
                label: "User List",
                key: "user_list",
                permissions: [
                    { label: "Access", value: USERS_ACCESS },
                    { label: "Add User", value: USERS_ADD },
                    { label: "Bulk Upload", value: USERS_BULK_UPLOAD },
                    { label: "Edit User", value: USERS_EDIT },
                    { label: "Disable User", value: USERS_DISABLE },
                ]
            },
            {
                label: "Bulk User Transaction",
                key: "bulk_user_transaction",
                permissions: [
                    { label: "Access", value: BULK_USER_TRANSACTION_ACCESS },
                    { label: "View Detail", value: BULK_USER_TRANSACTION_VIEW }
                ]
            },
            {
                label: "Role List",
                key: "role_list",
                permissions: [
                    { label: "Access", value: ROLE_ACCESS },
                    { label: "Add Role", value: ROLE_ADD },
                    { label: "Edit Role", value: ROLE_EDIT },
                    { label: "Delete Role", value: ROLE_DELETE },
                ]
            },
            {
                label: "Assign Permission",
                key: "assign_permission",
                permissions: [
                    { label: "Access", value: PERMISSION_ACCESS },
                    { label: "Add Permission", value: PERMISSION_ADD }
                ]
            }
        ]
    },
    {
        title: "Files Management",
        children: [
            {
                label: "File",
                key: "file_list",
                permissions: [
                    { label: "Access", value: FILE_ACCESS },
                    { label: "File Upload", value: FILE_ADD },
                    { label: "View", value: FILE_VIEW },
                    { label: "Approval", value: FILE_APPROVAL },
                ]
            },
        ]
    },
    {
        title: "Schedule, M & T",
        children: [
            {
                label: "Construction",
                key: "construction_list",
                permissions: [
                    { label: "Construction Access", value: CONSTRUCTION_ACCESS },
                ]
            },
            {
                label: "Schedule",
                key: "schedule_list",
                permissions: [
                    { label: "Schedule Access", value: SCHEDULE_ACCESS },
                ]
            },
            {
                label: "Milestone",
                key: "milestone_list",
                permissions: [
                    { label: "Milestone Access", value: MILESTONE_ACCESS },
                    { label: "View", value: MILESTONE_VIEW },
                    { label: "Approval", value: MILESTONE_APPROVAL },
                ]
            },
            {
                label: "Engineering",
                key: "engineering_list",
                permissions: [
                    { label: "Engineering Access", value: ENGINEERING_ACCESS },
                    { label: "Manage Drawing", value: ENGINEERING_MANAGE_DRAWING },
                    { label: "Add Document", value: ENGINEERING_DCOCUMENT_CREATE },
                    { label: "View Document", value: ENGINEERING_DCOCUMENT_VIEW },
                    { label: "Edit Document", value: ENGINEERING_DCOCUMENT_EDIT },
                    { label: "Approval Document", value: ENGINEERING_DCOCUMENT_APPROVAL },
                ]
            },
            {
                label: "Manpower",
                key: "manpower_list",
                permissions: [
                    { label: "Manpower Access", value: MANPOWER_ACCESS },
                ]
            },
            {
                label: "P&M",
                key: "p&m_list",
                permissions: [
                    {
                        label: 'Access',
                        value: PM_ACCESS
                    },
                    {
                        label: 'View',
                        value: PM_VIEW
                    },
                    {
                        label: 'Create',
                        value: PM_CREATE
                    },
                    {
                        label: 'Edit',
                        value: PM_EDIT
                    },
                    {
                        label: 'Delete',
                        value: PM_DELETE
                    },
                    {
                        label: 'Approval',
                        value: PM_APPROVAL
                    },
                ],
            },
            {
                label: "Monte Carlo Simulation",
                key: "monte_carlo_simulation_list",
                permissions: [
                    {
                        label: 'Access',
                        value: MONTE_CARLO_SIMULATION_ACCESS
                    },
                    {
                        label: 'Add',
                        value: MONTE_CARLO_SIMULATION_CREATE
                    },
                    {
                        label: 'View',
                        value: MONTE_CARLO_SIMULATION_VIEW
                    },
                    {
                        label: 'View Result',
                        value: MONTE_CARLO_SIMULATION_RESULT
                    },
                    {
                        label: 'Publish',
                        value: MONTE_CARLO_SIMULATION_PUBLISH
                    },
                ],
            },
            {
                label: "Bim Viewer",
                key: "bim_viewer",
                permissions: [
                    {
                        label: 'Access',
                        value: BIM_VIEWER_ACCESS
                    }
                ],
            },
        ]
    },
    {
        title: "Cost",
        children: [
            {
                label: "Financial Progress",
                key: "financial_list",
                permissions: [
                    { label: "Access", value: FINANCIAL_PROGRESS_ACCESS },
                ]
            },
            {
                label: "Payment Tracker",
                key: "payment_tracker_list",
                permissions: [
                    { label: "Access", value: PAYMENT_TRACKER_ACCESS },
                ]
            },
            {
                label: "BOQ",
                key: "boq_list",
                permissions: [
                    { label: "Access", value: BOQ_ACCESS },
                ]
            },
        ]
    },
    {
        title: "Procurement",
        children: [
            {
                label: "Vendor Performance Tracker",
                key: "vendor_performance_tracker_list",
                permissions: [
                    { label: "Access", value: VENDOR_PERFORMANCE_TRACKER_ACCESS },
                ]
            },
            {
                label: "Procurement",
                key: "procurement_list",
                permissions: [
                    { label: "Access", value: PROCUREMENT_ACCESS },
                ]
            },
        ]
    },
    {
        title: "Contracts & Claims",
        children: [
            {
                label: "Change Order",
                key: "change_order_list",
                permissions: [
                    {
                        label: 'Access',
                        value: CHANGE_ORDER_ACCESS
                    },
                    {
                        label: 'View',
                        value: CHANGE_ORDER_VIEW
                    },
                    {
                        label: 'Create',
                        value: CHANGE_ORDER_CREATE
                    },
                    {
                        label: 'Edit',
                        value: CHANGE_ORDER_EDIT
                    },
                    {
                        label: 'Delete',
                        value: CHANGE_ORDER_DELETE
                    },
                    {
                        label: 'Approval',
                        value: CHANGE_ORDER_APPROVAL
                    },
                ],
            },
            {
                label: "Claims",
                key: "claims_list",
                permissions: [
                    {
                        label: 'Access',
                        value: CLAIM_ACCESS
                    },
                    {
                        label: 'View',
                        value: CLAIM_VIEW
                    },
                    {
                        label: 'Create',
                        value: CLAIM_CREATE
                    },
                    {
                        label: 'Edit',
                        value: CLAIM_EDIT
                    },
                    {
                        label: 'Delete',
                        value: CLAIM_DELETE
                    },
                    {
                        label: 'Approval',
                        value: CLAIM_APPROVAL
                    },
                ],
            },
        ]
    },
    {
        title: "Risk",
        children: [
            {
                label: "Issues",
                key: "issues_list",
                permissions: [
                    {
                        label: 'Access',
                        value: KEY_ISSUE_ACCESS
                    },
                    {
                        label: 'View',
                        value: KEY_ISSUE_VIEW
                    },
                    {
                        label: 'Create',
                        value: KEY_ISSUE_CREATE
                    },
                    {
                        label: 'Edit',
                        value: KEY_ISSUE_EDIT
                    },
                    {
                        label: 'Delete',
                        value: KEY_ISSUE_DELETE
                    },
                    {
                        label: 'Approval',
                        value: KEY_ISSUE_APPROVAL
                    },
                ],
            },
            {
                label: "Risk",
                key: "risk_list",
                permissions: [
                    {
                        label: 'Access',
                        value: RISK_ACCESS
                    },
                    {
                        label: 'View',
                        value: RISK_VIEW
                    },
                    {
                        label: 'Create',
                        value: RISK_CREATE
                    },
                    {
                        label: 'Edit',
                        value: RISK_EDIT
                    },
                    {
                        label: 'Delete',
                        value: RISK_DELETE
                    },
                    {
                        label: 'Approval',
                        value: RISK_APPROVAL
                    },
                ],
            },
            {
                label: "Key Clearance",
                key: "key_clearance_list",
                permissions: [
                    {
                        label: 'Access',
                        value: KEY_CLEARANCE_ACCESS
                    },
                    {
                        label: 'View',
                        value: KEY_CLEARANCE_VIEW
                    },
                    {
                        label: 'Create',
                        value: KEY_CLEARANCE_CREATE
                    },
                    {
                        label: 'Edit',
                        value: KEY_CLEARANCE_EDIT
                    },
                    {
                        label: 'Delete',
                        value: KEY_CLEARANCE_DELETE
                    },
                    {
                        label: 'Approval',
                        value: KEY_CLEARANCE_APPROVAL
                    },
                ],
            },
            {
                label: "Safety",
                key: "safety_list",
                permissions: [
                    {
                        label: 'Access',
                        value: SAFETY_ACCESS
                    },
                    {
                        label: 'View',
                        value: SAFETY_VIEW
                    },
                    {
                        label: 'Create',
                        value: SAFETY_CREATE
                    },
                    {
                        label: 'Edit',
                        value: SAFETY_EDIT
                    },
                    {
                        label: 'Delete',
                        value: SAFETY_DELETE
                    },
                    {
                        label: 'Approval',
                        value: SAFETY_APPROVAL
                    },
                ],
            },
            {
                label: "Quality",
                key: "quality_list",
                permissions: [
                    {
                        label: 'Access',
                        value: QUALITY_ACCESS
                    },
                    {
                        label: 'View',
                        value: QUALITY_VIEW
                    },
                    {
                        label: 'Create',
                        value: QUALITY_CREATE
                    },
                    {
                        label: 'Edit',
                        value: QUALITY_EDIT
                    },
                    {
                        label: 'Delete',
                        value: QUALITY_DELETE
                    },
                    {
                        label: 'Approval',
                        value: QUALITY_APPROVAL
                    },
                ],
            },

        ]
    },
    {
        title: "Image Gallery",
        children: [
            {
                label: "Image Gallery",
                key: "gallery_list",
                permissions: [
                    {
                        label: 'Access',
                        value: IMAGE_GALLERY_ACCESS
                    },
                    {
                        label: 'View',
                        value: IMAGE_GALLERY_VIEW
                    },
                    {
                        label: 'Create',
                        value: IMAGE_GALLERY_CREATE
                    },
                    {
                        label: 'Edit',
                        value: IMAGE_GALLERY_EDIT
                    },
                    {
                        label: 'Delete',
                        value: IMAGE_GALLERY_DELETE
                    },
                    {
                        label: 'Approval',
                        value: IMAGE_GALLERY_APPROVAL
                    },
                ],
            },
        ]
    },
    {
        title: "DPR",
        children: [
            {
                label: "Quantity",
                key: "dpr_quantity_list",
                permissions: [
                    {
                        label: 'Access',
                        value: DPR_QUANTITY_ACCESS
                    },
                    {
                        label: 'Edit',
                        value: DPR_QUANTITY_EDIT
                    },
                ],
            },
            {
                label: "P&M",
                key: "dpr_p&m_list",
                permissions: [
                    {
                        label: 'Access',
                        value: DPR_PM_ACCESS
                    },
                    {
                        label: 'Edit',
                        value: DPR_PM_EDIT
                    },
                ],
            },
        ]
    },
    {
        title: "Config & Settings",
        children: [
            {
                label: "Project Settings",
                key: "project_settings_list",
                permissions: [
                    {
                        label: 'Access',
                        value: PROJECT_SETTING_ACCESS
                    },
                    {
                        label: 'Create',
                        value: PROJECT_SETTING_CREATE
                    },
                    {
                        label: 'View',
                        value: PROJECT_SETTING_VIEW
                    },
                    {
                        label: 'Edit',
                        value: PROJECT_SETTING_EDIT
                    },
                    {
                        label: 'Delete',
                        value: PROJECT_SETTING_DELETE
                    },
                ],
            },
            {
                label: "Norms",
                key: "norms_list",
                permissions: [
                    {
                        label: 'Access',
                        value: NORMS_ACCESS
                    },
                    {
                        label: 'Edit',
                        value: NORMS_EDIT
                    },
                ],
            },
            {
                label: "Workflow Management",
                key: "workflow_list",
                permissions: [
                    {
                        label: 'Access',
                        value: WORKFLOW_ACCESS
                    },
                    {
                        label: 'Create',
                        value: WORKFLOW_CREATE
                    },
                    {
                        label: 'Edit',
                        value: WORKFLOW_EDIT
                    },
                ],
            },
            {
                label: "Data Metrics Management",
                key: "data_metrics_list",
                permissions: [
                    {
                        label: 'Access',
                        value: DATA_METRICS_ACCESS
                    },
                    {
                        label: 'View',
                        value: DATA_METRICS_VIEW
                    },
                    {
                        label: 'Create',
                        value: DATA_METRICS_CREATE
                    },
                    {
                        label: 'Edit',
                        value: DATA_METRICS_EDIT
                    },
                    {
                        label: 'Delete',
                        value: DATA_METRICS_DELETE
                    },
                ],
            }
        ]
    },
    {
        title: "Help",
        children: [
            {
                label: "Feature List",
                key: "feature_list",
                permissions: [
                    {
                        label: 'Access',
                        value: HELP_FEATURE_LIST_ACCESS
                    }
                ],
            },
            {
                label: "Data Sets",
                key: "data_sets_list",
                permissions: [
                    {
                        label: 'Access',
                        value: HELP_DATA_SETS_LIST_ACCESS
                    }
                ],
            },
        ]
    },
];

const AssignPermission = () => {
    const [expandedModules, setExpandedModules] = useState({});
    const [selectedChildren, setSelectedChildren] = useState({});
    const [selectedModules, setSelectedModules] = useState([]);

    const theme = useTheme();
    const { projectId } = useParams();
    const formikRef = useRef();
    const rolesData = useGetAllRoleQuery({ projectId })
    const [assignPermissionFun, assignPermissionRes] = useAssignPermissionMutation();
    const [checkPermissionFun, checkPermissionRes] = useLazyGetCheckRolePermissionQuery();

    const [formData, setFormData] = useState({
        projectId: projectId,
        roleId: '',
    })

    const validationSchema = Yup.object({
        roleId: Yup.string().required("Role field is required."),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const countPermission = selectedModules.reduce(
            (acc, mod) => acc + (mod.permissions?.length || 0),
            0
        );
        if (countPermission == 0) {
            openNotification('At least one permission is required.', 'error')
            return
        }
        const transformed = {
            ...values,
            modules: selectedModules
        };

        assignPermissionFun(transformed);
    };

    useEffect(() => {
        if (assignPermissionRes?.isSuccess) {
            if (assignPermissionRes?.data?.status == 'success') {

                formikRef.current?.resetForm();
                openNotification(assignPermissionRes?.data?.message, 'success')
            } else {
                openNotification(assignPermissionRes?.data?.message, 'error')
            }
            setSelectedModules([])
        }
    }, [assignPermissionRes?.isSuccess]);

    useEffect(() => {
        if (assignPermissionRes?.isError) {
            if (assignPermissionRes?.error?.data?.status == 'fail') {
                openNotification(assignPermissionRes?.error?.data?.message, 'error')
            } else {
                openNotification(assignPermissionRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
        }
    }, [assignPermissionRes?.isError]);

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    const checkRolePermission = (roleId) => {
        checkPermissionFun(roleId)
    }

    useEffect(() => {

        if (checkPermissionRes?.status == "fulfilled") {
            // console.log(checkPermissionRes?.data?.modules?.flatMap(mod => mod.permissions));

            const flatUserPermissions = checkPermissionRes?.data?.modules?.flatMap(mod => mod.permissions);
            // Build selectedChildrenArray based on modules
            const selectedChildrenArray = menusModule?.flatMap((module) =>
                module?.children.map((child) => {
                    const matchedPermissions = child?.permissions
                        .filter((perm) => flatUserPermissions.includes(perm?.value))
                        .map((perm) => perm?.value);

                    if (matchedPermissions.length > 0) {
                        return {
                            moduleKey: child?.key,
                            moduleName: child.label,
                            title: module?.title,
                            permissions: matchedPermissions
                        };
                    }
                    return null;
                }).filter(Boolean)
            );
            setSelectedModules(selectedChildrenArray)
            const uniqueTitles = [...new Set(selectedChildrenArray?.map(item => item?.title))];
            const result = uniqueTitles.reduce((acc, curr) => {
                acc[curr] = true;
                return acc;
            }, {});
            setExpandedModules(result);
        }
    }, [checkPermissionRes]);

    const toggleModule = (title) => {
        setExpandedModules((prev) => ({
            ...prev,
            [title]: !prev[title]
        }));
    };

    const handleChildToggle = (childKey) => (event) => {
        const isChecked = event.target.checked;

        setSelectedModules((prev) => {
            if (isChecked) {
                // Add new module if not present
                if (!prev.find((mod) => mod.moduleKey === childKey?.key)) {
                    return [...prev, { moduleName: childKey?.label, moduleKey: childKey?.key, permissions: [] }];
                }
                return prev;
            } else {
                // Remove module
                return prev.filter((mod) => mod.moduleKey !== childKey?.key);
            }
        });
        // setSelectedChildren((prev) => ({
        //     ...prev,
        //     [childKey]: {
        //         ...(prev[childKey] || {}),
        //         checked: isChecked,
        //         permissions: isChecked ? (prev[childKey]?.permissions || []) : []
        //     }
        // }));
    };

    const handlePermissionToggle = (childKey, permValue) => (event) => {
        const isChecked = event.target.checked;

        setSelectedModules((prev) =>
            prev.map((mod) => {
                if (mod.moduleKey !== childKey) return mod;

                const updatedPermissions = isChecked
                    ? [...new Set([...mod.permissions, permValue])]
                    : mod.permissions.filter((p) => p !== permValue);

                return {
                    ...mod,
                    permissions: updatedPermissions
                };
            })
        );
    };

    const isChildChecked = (key) => !!selectedChildren[key]?.checked;
    const isModuleChecked = (moduleName) =>
        selectedModules.some((mod) => mod?.moduleKey === moduleName?.key);


    const isPermissionChecked = (childKey, permValue) =>

        // selectedModules[childKey]?.permissions?.[permValue] || false;
        selectedModules
            .find((mod) => mod?.moduleKey === childKey)
            ?.permissions?.includes(permValue) || false;

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                        Assign Permission
                    </Typography>
                </Box>
            </Grid2>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Formik
                        innerRef={formikRef}
                        initialValues={formData}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid2 container spacing={2}>

                                    <Grid2 size={6}>
                                        <Autocomplete
                                            options={rolesData?.data?.data || []}
                                            getOptionLabel={(option) => option?.displayName}
                                            value={rolesData?.data?.data?.find((option) => option?.id === values?.roleId) || null}
                                            onChange={(_, newValue) => {
                                                setFieldValue("roleId", newValue ? newValue?.id : "")
                                                checkRolePermission(newValue?.id);
                                            }}
                                            onBlur={() => setTouched({ ...touched, roleId: true })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Role"
                                                    placeholder='Select Role'
                                                    name="roleId"
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                    variant="filled"
                                                />
                                            )}
                                            ListboxProps={{
                                                sx: { fontSize: "13px" },
                                            }}
                                        />
                                        {touched?.roleId && errors?.roleId &&
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.roleId}`}</FormHelperText>
                                        }

                                    </Grid2>
                                    <Grid2 size={6}>
                                        <Button
                                            type='submit'
                                            loading={assignPermissionRes?.isLoading}
                                            variant="contained"
                                            sx={{
                                                backgroundColor: `${theme?.customSettings?.themeColor}`,
                                                color: '#FFF',
                                                fontWeight: '500', textTransform: 'none',
                                                fontSize: '16px', float: 'right'
                                            }}>
                                            Save
                                        </Button>
                                    </Grid2>

                                    {/* <Grid2 size={12}>
                                        <FieldArray name="modules">
                                            {() => (
                                                <>
                                                    {values.modules.map((step, index) => {
                                                        const module = modules.find(
                                                            (m) => m.moduleName === step.moduleName
                                                        );

                                                        return (
                                                            <Paper
                                                                key={index}
                                                                elevation={1}
                                                                sx={{ p: 1, pl: 2, mb: 1, borderRadius: 1 }}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{ fontWeight: 600, mb: 1 }}
                                                                >
                                                                    {step.moduleName}
                                                                </Typography>

                                                                <Grid2 container spacing={2}>
                                                                    {module.permissions.map((permission, i) => (
                                                                        <Grid2 size={{ xs: 12, md: 2.4, sm: 6 }} key={i}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={step.permissions.includes(permission)}
                                                                                        onChange={(e) => {
                                                                                            const newPermissions = step.permissions.includes(
                                                                                                permission
                                                                                            )
                                                                                                ? step.permissions.filter(
                                                                                                    (p) => p !== permission
                                                                                                )
                                                                                                : [...step.permissions, permission];

                                                                                            setFieldValue(
                                                                                                `modules[${index}].permissions`,
                                                                                                newPermissions
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label={permission?.label}
                                                                            />
                                                                        </Grid2>
                                                                    ))}
                                                                </Grid2>
                                                            </Paper>
                                                        );
                                                    })}
                                                </>
                                            )}
                                        </FieldArray>
                                    </Grid2> */}
                                </Grid2>
                            </form>
                        )}
                    </Formik>
                </Grid2>
                <Grid2 size={3}>
                    <Paper sx={{ p: 2, boxShadow: 'none' }}>
                        <Typography variant="body2" gutterBottom sx={{ display: 'block', mb: 2 }}>
                            Menus
                        </Typography>
                        {menusModule?.map((mod, ind) => (
                            <Box key={mod.title}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => toggleModule(mod.title)}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '17px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                                        {mod.title}
                                    </Typography>
                                    <IconButton size="small">
                                        {/* {expandedModules[mod.title] ? <ExpandLessIcon /> : <ExpandMoreIcon />} */}
                                        {expandedModules[mod.title] ? <ChevronUPIcon style={{height:"20px", width:"20px"}} /> : <ChevronDownIcon style={{height:"20px", width:"20px"}} />}
                                    </IconButton>
                                </Box>

                                <Collapse in={expandedModules[mod.title]}>
                                    <FormGroup sx={{ pl: 1 }}>
                                        {mod.children.map((child) => (
                                            <FormControlLabel
                                                key={child.key}
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={isModuleChecked(child)}
                                                        onChange={handleChildToggle(child)}
                                                    />
                                                }
                                                label={child.label}
                                            />
                                        ))}
                                    </FormGroup>
                                </Collapse>
                                {menusModule?.length != ind + 1 &&
                                    <Divider sx={{ mb: 1, mt: 1 }} />
                                }
                            </Box>
                        ))}
                    </Paper>
                </Grid2>

                {/* Right Side */}
                <Grid2 size={9}>
                    <Paper sx={{ p: 2, boxShadow: 'none' }}>
                        {/* <Typography variant="body2" gutterBottom sx={{ display: 'block', mb: 2 }}>
                            Actions
                        </Typography> */}
                        <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '17px', color: `#182A4E`, mb: 1 }}>
                            Actions
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        {menusModule?.map((mod) =>
                            mod.children.map((child) =>
                                isModuleChecked(child) ? (
                                    <Box key={child.key} sx={{ mb: 3 }}>
                                        <Typography variant="subtitle1" gutterBottom sx={{ mb: 0 }}>
                                            {child.label}
                                        </Typography>
                                        <Grid2 container spacing={2}>
                                            {child.permissions.map((perm) => (
                                                <Grid2 size={3} key={perm.value} sx={{ pl: 1 }}>
                                                    <FormControlLabel
                                                        sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={isPermissionChecked(child.key, perm.value)}
                                                                onChange={handlePermissionToggle(child.key, perm.value)}
                                                            />
                                                        }
                                                        label={perm.label}
                                                    />
                                                </Grid2>
                                            ))}
                                        </Grid2>
                                    </Box>
                                ) : null
                            )
                        )}
                    </Paper>
                </Grid2>
            </Grid2>
        </>
    );
};

export default AssignPermission;
